import React from "react";
import LegalLayout from "./ui/LegalLayout";

const SupportLink = () => (
  <a href="mailto:contact@hyphentech.africa">AgriHyphen AI support</a>
);

const SECTIONS = [
  {
    title: "Introduction",
    body: (
      <p>
        AgriHyphen AI respects your privacy. This Privacy Policy explains how we
        collect, use, and protect information when you use our application and
        services. We follow applicable privacy norms and industry best practices
        to safeguard your information.
      </p>
    ),
  },
  {
    title: "Information We Collect",
    body: (
      <ul>
        <li>Images you upload to the app for plant disease detection.</li>
        <li>
          Basic usage information such as device and interaction data, used to
          improve the service.
        </li>
      </ul>
    ),
  },
  {
    title: "How We Use Your Information",
    body: (
      <p>
        Uploaded images may be stored and used to improve our AI models and
        overall service quality. We may also use aggregated, anonymised data for
        research and development.
      </p>
    ),
  },
  {
    title: "Data Sharing",
    body: (
      <p>
        We do not sell your personal data. We may share data with trusted
        service providers who process it on our behalf under strict
        confidentiality and security obligations.
      </p>
    ),
  },
  {
    title: "Data Security and Retention",
    body: (
      <p>
        We implement reasonable technical and organisational measures to protect
        data. Uploaded images used to improve models may be retained for as long
        as necessary for research and service enhancement, after which they may
        be anonymised or deleted.
      </p>
    ),
  },
  {
    title: "Your Choices",
    body: (
      <p>
        If you have questions about your data, or wish to request deletion of
        identifiable information associated with your account, please contact
        us.
      </p>
    ),
  },
  {
    title: "Contact",
    body: (
      <p>
        For privacy inquiries, contact <SupportLink />.
      </p>
    ),
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      updated="15 October 2025"
      sections={SECTIONS}
    />
  );
}
